import React from 'react';
import './Checkout.css';
import Subtotal from './Subtotal'
import { useStateValue } from './StateProvider';
import CheckoutProduct from './CheckoutProduct';
import Clock from './Clock';

function Checkout(){
    const[{basket},dispatch]=useStateValue();

    return(
        <div className="checkout">
            <div style={{display:'none'}}><Clock/></div>
            <div className="checkout__left">
                <img className="checkout__ad" alt="adertisment"  src={'assets/offer3.jpg'} />
                 <div>
                     <h2 className="checkout__title">Your Shopping Basket</h2>
                      {basket.map(item=>(
                          <CheckoutProduct
                             id={item.id}
                             title={item.title}
                             image={item.image}
                             price={item.price}
                             rating={item.rating}
                          />
                      ))}
                     
                 </div>
            </div>
            <div className="checkout__right">
                <Subtotal/>
            </div>

        </div>
    )
}
export default Checkout;